import { render, staticRenderFns } from "./EndorsementContractBonus.vue?vue&type=template&id=b6de956e"
import script from "./EndorsementContractBonus.vue?vue&type=script&lang=js"
export * from "./EndorsementContractBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports